// import React, { useMemo } from "react";
import Router from "./router";
import AppSidebar from "./components/Layout/AppSidebar";
import AppHeader from "./components/Layout/AppHeader";
import AppFooter from "./components/Layout/AppFooter";
import { useAuth } from "./context/AuthProvider";
import "./styles/main.scss";
import CollapsibleSidebarLayout from "./components/Layout/CollapsibleSidebarLayout";
// import { useScreen } from "./context/ScreenProvider";
// import BlockModal from "./components/Misc/BlockModal";

function App() {
  const { isAuthenticated } = useAuth();
  // const { screenWidth, screenHeight } = useScreen() || {
  //   screenWidth: 0,
  //   screenHeight: 0,
  // };

  // const isSmallScreen = useMemo(
  //   () => screenWidth < 900,
  //   [screenWidth, screenHeight]
  // );

  // const isDeviceWithoutHover = useMemo(
  //   () => window.matchMedia("(any-hover: none)").matches,
  //   [screenWidth, screenHeight]
  // );

  // const isMobile = useMemo(
  //   () => isDeviceWithoutHover || isSmallScreen,
  //   [screenWidth, screenHeight] // eslint-disable-line react-hooks/exhaustive-deps
  // );

  return (
    <div className={`app`}>
      {/* {isMobile && (
        <BlockModal
          title={"Best Viewed on Desktop"}
          badge={"question circle outline"}
          enable={{
            setter: null,
            value: true,
          }}
        >
          <>
            <br />
            <p>
              DECODER has not been optimized for mobile or tablet devices yet,
              but we are working hard to make this happen soon. Please check
              back at a later date.
            </p>
          </>
        </BlockModal>
      )} */}
      {isAuthenticated && <AppHeader />}
      <div className="page-wrap">
        <CollapsibleSidebarLayout
          minSidebarWidth={240}
          maxSidebarWidth={400}
          initialSidebarWidth={250}
          icon={"bars"}
          label={"Menu"}
          id="app-sb"
          sidebar={isAuthenticated ? <AppSidebar /> : null}
          main={<Router />}
          isInverse={false}
        />
      </div>
      {isAuthenticated && <AppFooter />}
    </div>
  );
}

export default App;
